import React from 'react';
import PropTypes from 'prop-types';

import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Result from '@Components/Results/Result';
import RsTableRow from '@Pages/RetroSynthesis/components/RsTable/RsTableRow';
import { Checkbox } from '@els/els-react--checkbox';
import cn from 'classnames';

import './ExamplesTableItem.scss';

function ExamplesTableItem({ exampleNo, reactionId, score, metadata, result, isVisible, isChecked, setChecked, renderCheckboxesColumn }) {
  return (
    <RsTableRow className={cn('examples-table-item', { 'not-visible': !isVisible })}>
      {renderCheckboxesColumn && (
        <td className="table-row__number-checkbox c-els-table__cell c-els-table__basic-cell">
          <div className="table-row__number-checkbox__wr">
            <div className="table-row__number-checkbox__wr__checkbox">
              <Checkbox
                data-e2e={`examples-table-item-checkbox-${exampleNo}`}
                id={`element${exampleNo}`}
                label={`Select ${exampleNo}`}
                shouldHideLabel
                checked={isChecked}
                onChange={() => setChecked(reactionId, !isChecked)}
              />
            </div>
            <div className="table-row__number-checkbox__wr__label">{exampleNo}</div>
          </div>
        </td>
      )}
      {!renderCheckboxesColumn && <td className="table-row__number">{exampleNo}</td>}
      <td className="table-row__reaction c-els-table__cell c-els-table__basic-cell">
        <div className="examples-table-item__reaction rx-list rx-list--reactions">
          {result ? (
            <Result
              key={result.id}
              context="reactions"
              hideCheckbox
              result={result}
              metadata={{
                ...metadata,
                expandConditions: exampleNo === 1,
                fromRT: true,
              }}
            />
          ) : (
            <SimpleSpinner className="examples-table-item__reaction-loader rx-loader--container__relative" />
          )}
        </div>
      </td>
      <td className="table-row__score c-els-table__cell c-els-table__basic-cell">{score}</td>
    </RsTableRow>
  );
}

ExamplesTableItem.propTypes = {
  exampleNo: PropTypes.number,
  reactionId: PropTypes.string,
  score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  metadata: PropTypes.object,
  result: PropTypes.object,
  isVisible: PropTypes.bool,
  isChecked: PropTypes.bool,
  setChecked: PropTypes.func,
  renderCheckboxesColumn: PropTypes.bool,
};

export default ExamplesTableItem;
